import { app } from '../../../../../../app';
import { Controller } from './delete.controller';

app.component('deleteProfile', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./delete.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/main/delete/delete.component.js